import SectionHeading from "@/components/base/SectionHeading";
import Reveal from "@/components/base/Reveal";
import { plotSections } from "@/mocks/film";

export default function PlotSection() {
  return (
    <section id="plot" className="scroll-mt-32 bg-background-100 py-14 md:py-20">
      <div className="px-4 md:px-6">
        <Reveal>
          <SectionHeading
            index="02 / 剧情介绍"
            title="按三幕结构，把故事讲完整"
            desc="这段剧情介绍按影片的分幕顺序展开，从妹妹搬进姐姐家的日常，到三人各自做出选择。每一幕都补充了具体场景与细节，方便与后文的角色、演员表互相印证。"
          />
        </Reveal>

        <Reveal delay={60}>
          <figure className="mt-8 md:mt-10">
            <div className="w-full h-56 md:h-[420px] rounded-lg overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Warm%20cinematic%20still%20of%20a%20quiet%20family%20dinner%20table%20with%20steaming%20soup%20bowls%20and%20simple%20home%20dishes%2C%20soft%20amber%20overhead%20light%2C%20muted%20terracotta%20and%20cream%20tones%2C%20cozy%20modest%20apartment%20interior%2C%20shallow%20depth%20of%20field%2C%20editorial%20film%20aesthetic%2C%20no%20people%2C%20high%20detail%2C%20harmonious%20composition&width=1600&height=900&seq=film-plot-dinner-01&orientation=landscape"
                alt="影片中一家人围坐餐桌的场景氛围图"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <figcaption className="mt-3 text-xs md:text-sm text-foreground-500">
              第一幕的关键场景多发生在餐桌：热汤、剩菜与迟到的座位，构成三人关系的底色。
            </figcaption>
          </figure>
        </Reveal>

        <div className="mt-8 md:mt-12 grid grid-cols-1 lg:grid-cols-3 gap-5 md:gap-6">
          {plotSections.map((section, index) => (
            <Reveal key={section.id} delay={index * 80}>
              <article className="h-full rounded-lg bg-background-50 border border-background-200 p-5 md:p-6 flex flex-col">
                <div className="flex items-center gap-3">
                  <span className="w-8 h-8 rounded-md bg-primary-500 text-background-50 flex items-center justify-center font-label text-sm">
                    {index + 1}
                  </span>
                  <span className="font-label text-xs tracking-wider text-primary-700">
                    {section.act}
                  </span>
                </div>
                <h3 className="font-heading mt-4 text-lg md:text-xl font-bold text-foreground-950">
                  {section.title}
                </h3>
                <div className="mt-3 space-y-3 text-sm leading-relaxed text-foreground-700">
                  {section.paragraphs.map((paragraph) => (
                    <p key={paragraph.slice(0, 16)}>{paragraph}</p>
                  ))}
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}